var _circle, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBoardTextDelete(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 21,
    viewBox: "0 0 21 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 10.9688,
    cy: 10.4141,
    r: 10,
    fill: "#CBCBCB"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.2995 7.07813L7.63281 13.7448M14.2995 13.7448L7.63281 7.07812",
    stroke: "#6F6F6F",
    strokeWidth: 1.67025,
    strokeLinecap: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBoardTextDelete);
export default __webpack_public_path__ + "static/media/BoardTextDelete.18685efd74e9b6a59fc844d3264689dd.svg";
export { ForwardRef as ReactComponent };